export default __webpack_public_path__ + "static/media/IMG_2850 copie.f84a5099.jpg";